export default "/images/shildikUzb.svg?a10019d3bfda33e51f20aa22446e1751";